import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
} from 'react';
import PropTypes from 'prop-types';
import { init, track } from '@amplitude/analytics-browser';
import { createLog } from 'services/logService';

const AmplitudeContext = createContext();

export function AmplitudeProvider({ children }) {
  const amplitudeInitialized = useRef(false);

  useEffect(() => {
    if (!amplitudeInitialized.current) {
      if (process.env.AMPLITUDE_API_KEY && JSON.parse(process.env.PRODUCTION)) {
        try {
          init(process.env.AMPLITUDE_API_KEY);
        } catch (error) {
          createLog('Amplitude initialization failed', error);
        }
      }
      amplitudeInitialized.current = true;
    }
  }, []);

  const trackAmplitudeEvent = useCallback((eventName, eventProperties) => {
    track(eventName, eventProperties);
  }, []);

  const value = useMemo(() => ({ trackAmplitudeEvent }), [trackAmplitudeEvent]);

  return (
    <AmplitudeContext.Provider value={value}>
      {children}
    </AmplitudeContext.Provider>
  );
}

AmplitudeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAmplitude = () => {
  const context = useContext(AmplitudeContext);

  if (!context) {
    throw new Error('useAmplitude must be used within a AmplitudeContext');
  }

  return context;
};
